"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TextInfo_form_1 = __importDefault(require("./TextInfo.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const AriFormUtils = __importStar(require("../../../utils/utils"));
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const AriForm_1 = require("../../../AriForm");
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class TextInfoComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.checks = [];
        this.textContent = this.component.textContent || '';
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'textinfo',
            label: 'TextInfo',
            displayInfo: false,
            textContent: '',
            align: 'justify-content-start',
            action: 'event',
            templatesTextinfo: TextInfoComponent.defaultRowTemplate,
        }, ...extend);
    }
    get defaultSchema() {
        return TextInfoComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    static get defaultRowTemplate() {
        return `
  <table class="table table-bordered">
  <thead>
    <tr>
      <th>Phone</th>
      <th>Name</th>
    </tr>
  </thead>
  <tbody>
    <% for (var i = 0; i < value?.length; i++) { %>
      <tr>
        <td><%= value[i].phone %></td>
        <td><%= value[i].name %></td>
      </tr>
    <% } %>
  </tbody>
</table>

  `;
    }
    get modalRef() {
        return `${this.component.key}-modal-file`;
    }
    get fileTriggerRef() {
        return `${this.component.key}-ari-view-file`;
    }
    get imageTriggerRef() {
        return `${this.component.key}-ari-view-image`;
    }
    get showFileRef() {
        return `${this.component.key}-show-file`;
    }
    getFileUrl(file) {
        if (!file) {
            return '';
        }
        if (typeof file === 'string') {
            return file;
        }
        return file.url || file.href || file.value || file.path || '';
    }
    getFileName(file, fallback = 'file') {
        if (!file) {
            return AriFormUtils.getLangText(fallback);
        }
        if (typeof file === 'object') {
            return file.name || file.label || AriFormUtils.getLangText(fallback);
        }
        const cleanUrl = file.split('?')[0].split('#')[0];
        return cleanUrl.split('/').pop() || AriFormUtils.getLangText(fallback);
    }
    getFileExtension(file) {
        const url = this.getFileUrl(file);
        const cleanUrl = url.split('?')[0].split('#')[0];
        return (cleanUrl.split('.').pop() || '').toLowerCase();
    }
    getFileList(value) {
        if (!value) {
            return [];
        }
        return Array.isArray(value) ? value : [value];
    }
    isImageExtension(ext) {
        return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'avif'].includes(ext);
    }
    getFileIcon(file) {
        return this.isImageExtension(this.getFileExtension(file)) ? 'image' : 'insert_drive_file';
    }
    renderFilePreview(file, index = 0) {
        const label = this.isImageExtension(this.getFileExtension(file))
            ? AriFormUtils.getLangText('View Image')
            : AriFormUtils.getLangText('View File');
        const title = lodash_1.default.escape(this.getFileName(file));
        return `<button type="button"
                    class="ari-text-info-preview-btn ${this.component.key}-ari-view-file ari-appearance-none ari-border-0 ari-bg-transparent ari-text-[#0d6efd] hover:ari-text-[#084298] hover:ari-underline ari-cursor-pointer ari-p-0 ari-leading-normal ari-flex ari-items-center ari-gap-2 ari-font-semibold"
                    ref="${this.fileTriggerRef}"
                    data-preview-index="${index}"
                    title="${title}">
                    <span class="material-icons">${this.getFileIcon(file)}</span>
                    <span>${label}</span>
                  </button>`;
    }
    showTypeOfValue(value) {
        const show = this.component.showfile; // biến xác định kiểu hiển thị
        switch (this.component.showType) {
            case 'text':
                return `${AriFormUtils.getLangText(value || '-')}`;
            case 'number':
                return value ? AriFormUtils.numberWithCommas(value, 0) : '-';
            case 'amount':
                return value
                    ? `${AriFormUtils.numberWithCommas(value)} ${this.component.showCurrency}`
                    : '-';
            case 'datetime':
                return value ? (0, moment_1.default)(value).format('DD/MM/YYYY') : '-';
            case 'link': {
                if (!value)
                    return '-';
                if (show) {
                    return '';
                }
                // value là object
                if (typeof value === 'object') {
                    const url = value.url || value.href;
                    const text = value.name || value.label || AriFormUtils.getLangText('file');
                    if (!url)
                        return '-';
                    return `<a href="${lodash_1.default.escape(url)}" target="_blank" rel="noopener noreferrer">${lodash_1.default.escape(text)}</a>`;
                }
                // value là string (fallback)
                return `<a href="${lodash_1.default.escape(value)}" target="_blank" rel="noopener noreferrer">${AriFormUtils.getLangText('file')}</a>`;
            }
            case 'file': {
                if (!value)
                    return '-';
                if (show) {
                    return '';
                }
                return this.getFileList(value)
                    .map((file, index) => this.renderFilePreview(file, index))
                    .join('');
            }
            case 'esign': {
                if (!value) {
                    return '-';
                }
                if (show) {
                    return ` `;
                }
                else {
                    if (typeof value === 'string') {
                        return this.renderFilePreview(value);
                    }
                    else {
                        if (value.formatType === 'link') {
                            return `<a href="${lodash_1.default.escape(value.value)}" class="ari-font-semibold" target="_blank" rel="noopener noreferrer">${AriFormUtils.getLangText('View contract')}</a>`;
                        }
                        else {
                            return this.renderFilePreview(value.value || value);
                        }
                    }
                }
            }
            case 'img': {
                if (show) {
                    if (typeof value === 'string' || !Array.isArray(value)) {
                        return `<img src="${lodash_1.default.escape(this.getFileUrl(value))}" alt="image" class="${this.previewImageClass}">`;
                    }
                    else {
                        return this.renderCaroselImages(value);
                    }
                }
                else {
                    return `<button type="button" class="ari-text-info-preview-btn ari-appearance-none ari-border-0 ari-bg-transparent ari-text-[#0d6efd] hover:ari-text-[#084298] hover:ari-underline ari-cursor-pointer ari-p-0 ari-leading-normal ari-flex ari-items-center ari-gap-2 ari-font-semibold" ref="${this.imageTriggerRef}">
        <span class="material-icons">image</span> 
        <span>${AriFormUtils.getLangText('View Image')}</span>
      </button>`;
                }
            }
            default:
                return '-';
        }
    }
    renderImageSwiper(images) {
        return this.getFileList(images).map((value) => {
            return `<div class="swiper-slide"><img src="${lodash_1.default.escape(this.getFileUrl(value))}" alt="image" class="${this.previewImageClass}"></div>`;
        });
    }
    renderCaroselImages(images) {
        return `<div class="swiper image-swiper-${this.component.key} ari-w-full ari-h-full">
              <div class="swiper-wrapper">
                ${this.renderImageSwiper(images).join('')}
              </div>
              <div class="swiper-pagination"></div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
              <div class="swiper-scrollbar"></div>
            </div>`;
    }
    get modalDialogClass() {
        return 'modal-dialog modal-dialog-scrollable ari-w-screen ari-max-w-none ari-h-screen ari-m-0';
    }
    get modalContentClass() {
        return 'modal-content ari-relative ari-h-screen ari-max-h-none ari-border-0 ari-rounded-none ari-overflow-hidden ari-bg-[#020617] ari-shadow-none';
    }
    get modalBodyClass() {
        return 'modal-body ari-h-full ari-bg-[#020617] ari-p-0 ari-overflow-auto';
    }
    get modalPreviewClass() {
        return 'ari-text-info-modal-preview ari-flex ari-h-full ari-min-h-full ari-items-center ari-justify-center';
    }
    get previewImageClass() {
        return 'ari-text-info-preview-image ari-rounded-md ari-block ari-max-h-full ari-max-w-full ari-object-contain';
    }
    get previewFrameClass() {
        return 'ari-text-info-preview-frame ari-block ari-bg-white ari-border-0 ari-h-full ari-min-h-full ari-w-full';
    }
    get fallbackClass() {
        return 'ari-text-info-preview-fallback ari-bg-white ari-border ari-border-[#e5e7eb] ari-rounded-[10px] ari-p-6 ari-text-center';
    }
    get modalCloseButtonClass() {
        return 'btn ari-text-info-modal-close ari-absolute ari-right-3 ari-bottom-3 ari-z-20 ari-w-11 ari-h-11 ari-rounded-full ari-flex ari-items-center ari-justify-center ari-bg-[#111827]/70 hover:ari-bg-[#111827]/90 ari-backdrop-blur ari-border ari-border-white/25 ari-shadow-lg ari-p-0 ari-text-white';
    }
    getValueFromTextContent(textContent) {
        const form = this.getRoot();
        const flattened = {};
        const components = {};
        AriFormUtils.eachComponent(form.components, (componentWrapper, path) => {
            const component = componentWrapper.component || componentWrapper;
            flattened[path] = component;
            components[component.key] = component;
        }, true);
        const a = this.evaluate(textContent, {
            form,
            flattened,
            components
        }, 'value');
        return a;
    }
    renderPopup(value) {
        const imageValue = value || this.textContent;
        return `<div class="modal fade ari-text-info-modal" id="viewImageModal-${this.component.key}" tabindex="-1" role="dialog" aria-labelledby="viewImageModalLabel" aria-hidden="true">
      <div class="${this.modalDialogClass}" role="document">
        <div class="${this.modalContentClass}">
          <div class="${this.modalBodyClass}">
            <div class="${this.modalPreviewClass}">
              ${typeof imageValue === 'string' || !Array.isArray(imageValue) ? `<img src="${lodash_1.default.escape(this.getFileUrl(imageValue))}" class="${this.previewImageClass}" alt="Responsive image"> ` : this.renderCaroselImages(imageValue)}
            </div>
          </div>
          <button type="button" class="${this.modalCloseButtonClass}" data-bs-dismiss="modal" data-dismiss="modal" aria-label="${AriFormUtils.getLangText('Close')}">
            <span class="material-icons ari-text-[28px]">close</span>
          </button>
        </div>
      </div> 
      </div>`;
    }
    render() {
        const dataValue = this.component.textContent ? this.getValueFromTextContent(this.textContent) : this.textContent;
        var view = `<div class="ari-text-info-wraper ${this.component.hideWhenEmpty && !dataValue ? 'd-none' : ''}  " ref="element">
                     <div class="col-form-value ari-pt-[calc(.375rem+1px)] ari-pb-[calc(.375rem+1px)] ari-mb-0 ari-text-[inherit] ari-leading-normal ari-flex ari-items-center ari-gap-2 ${this.component.showfile && this.component.showType === 'file' ? 'd-none' : ''}">${this.showTypeOfValue(dataValue)}</div>
                      ${this.component.showType === 'img' && !this.component.showfile ? this.renderPopup(dataValue) : ''}
                      ${this.component.showType === 'file' && !this.component.showfile ? this.renderFile(dataValue) : ''}
                      ${this.component.showType === 'esign' && (dataValue && typeof dataValue !== 'string' && dataValue.formatType === 'doc') && !this.component.showfile ? this.renderFile(dataValue.value || '') : ''}
                      ${this.component.showfile ? `<div ref="${this.showFileRef}" class="show-file"></div>` : ''}
                </div>`;
        var templateStr = lodash_1.default.get(this.component, 'templatesTextinfo');
        var renderByTemplate = lodash_1.default.template(templateStr);
        let valueInfo = dataValue;
        if (typeof dataValue === 'string' &&
            dataValue &&
            this.component.showType === 'list') {
            try {
                valueInfo = JSON.parse(dataValue);
            }
            catch (e) {
                // fallback: giữ nguyên string
                valueInfo = dataValue;
            }
        }
        const form = this.getRoot();
        var html = renderByTemplate({
            value: valueInfo,
            form,
            utils: AriFormUtils,
            data: form.getValue().data,
            _: lodash_1.default,
            moment: moment_1.default
        });
        return super.render(this.component.showType === 'list' ? html : view);
    }
    setValue(value, flags = {}) {
        const changed = super.setValue(value, flags);
        if (changed) {
            this.textContent = value || '';
            this.redraw();
        }
        return changed;
    }
    getValue() {
        return this.value;
    }
    renderFile(file) {
        if (file) {
            if (typeof file === 'string') {
                return `<div class="${this.component.key}-wraper-file">${this.renderPopupFile(0)}</div>`;
            }
            else {
                const files = Array.isArray(file) ? file : [file];
                return `<div class="${this.component.key}-wraper-files-list">${files.map((_, key) => this.renderPopupFile(key)).join('')}</div>`;
            }
        }
        else {
            return '';
        }
    }
    renderPopupFile(key) {
        return `<div class="modal fade ari-text-info-modal ${this.component.key}-modal-file-${key}"
  ref="${this.modalRef}" data-preview-index="${key}" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="${this.modalDialogClass}" role="document">
    <div class="${this.modalContentClass}">
      <div class="${this.modalBodyClass}">
        <div class="modal-content-file ${this.modalPreviewClass}"></div>
      </div>
      <button type="button" class="${this.modalCloseButtonClass}" data-bs-dismiss="modal" data-dismiss="modal" aria-label="${AriFormUtils.getLangText('Close')}">
        <span class="material-icons ari-text-[28px]">close</span>
      </button>
    </div>
  </div>
</div>`;
    }
    renderItem(type, value, ext, previewEl) {
        const fileUrl = this.getFileUrl(value);
        const fileName = lodash_1.default.escape(this.getFileName(value));
        if ((type === 'file' || type === 'esign' || type === 'img') && fileUrl) {
            if (ext === 'pdf') {
                const iframe = document.createElement('iframe');
                const viewerUrl = `${AriForm_1.AriForm.pdfjsURL}?file=${encodeURIComponent(fileUrl)}`;
                iframe.src = viewerUrl;
                iframe.className = this.previewFrameClass;
                iframe.title = fileName;
                previewEl.innerHTML = '';
                previewEl.appendChild(iframe);
            }
            else if (this.isImageExtension(ext)) {
                const image = document.createElement('img');
                image.src = fileUrl;
                image.alt = fileName;
                image.className = this.previewImageClass;
                previewEl.innerHTML = '';
                previewEl.appendChild(image);
            }
            else if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext)) {
                const iframe = document.createElement('iframe');
                iframe.src = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
                iframe.className = this.previewFrameClass;
                iframe.title = fileName;
                previewEl.innerHTML = '';
                previewEl.appendChild(iframe);
            }
            else {
                previewEl.innerHTML = `<div class="${this.fallbackClass}">
          <div class="ari-font-semibold ari-mb-2">${fileName}</div>
          <a href="${lodash_1.default.escape(fileUrl)}" target="_blank" rel="noopener noreferrer">${AriFormUtils.getLangText('Open file')}</a>
        </div>`;
            }
        }
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        var refs = {};
        refs[this.imageTriggerRef] = 'single';
        refs[this.showFileRef] = 'single';
        refs[this.modalRef] = 'multiple';
        refs[this.fileTriggerRef] = 'multiple';
        this.loadRefs(element, refs);
        const previewEl = this.refs[this.showFileRef];
        let value = this.component.textContent ? this.getValueFromTextContent(this.textContent) : this.textContent || '';
        const show = this.component.showfile;
        const type = this.component.showType;
        if (show && previewEl) {
            const fileValue = type === 'esign' && typeof value === 'object' ? value.value : value;
            const firstFile = Array.isArray(fileValue) ? fileValue[0] : fileValue;
            const ext = this.getFileExtension(firstFile);
            this.renderItem(type, firstFile, ext, previewEl);
        }
        if (this.refs[this.imageTriggerRef]) {
            this.addEventListener(this.refs[this.imageTriggerRef], 'click', () => {
                // eslint-disable-next-line no-undef
                jQuery(`#viewImageModal-${this.component.key}`).modal('toggle');
            });
        }
        if (value && (type === 'file' || (type === 'esign' && value.formatType === 'doc')) && !show) {
            value = type === 'file' ? value : value.value;
            const files = Array.isArray(value) ? value : [value];
            const modals = Array.from(this.refs[this.modalRef] || []);
            const triggers = Array.from(this.refs[this.fileTriggerRef] || []);
            files.forEach((file, index) => {
                const modal = modals[index];
                const modalPreview = modal && modal.querySelector('.modal-content-file');
                if (modalPreview) {
                    this.renderItem(type, file, this.getFileExtension(file), modalPreview);
                }
            });
            triggers.forEach((trigger) => {
                this.addEventListener(trigger, 'click', () => {
                    const index = Number(trigger.getAttribute('data-preview-index') || 0);
                    const modal = modals[index];
                    if (modal) {
                        // eslint-disable-next-line no-undef
                        jQuery(modal).modal('toggle');
                    }
                });
            });
        }
        Array.from(element.querySelectorAll('.ari-text-info-modal-close')).forEach((button) => {
            this.addEventListener(button, 'click', () => {
                const modal = button.closest('.modal');
                if (modal) {
                    // eslint-disable-next-line no-undef
                    jQuery(modal).modal('hide');
                }
            });
        });
        const SwiperClass = window.Swiper;
        if (element.querySelector(`.image-swiper-${this.component.key}`) && SwiperClass) {
            new SwiperClass(`.image-swiper-${this.component.key}`, {
                navigation: {
                    nextEl: `.image-swiper-${this.component.key} .swiper-button-next`,
                    prevEl: `.image-swiper-${this.component.key} .swiper-button-prev`,
                },
                pagination: {
                    el: `.image-swiper-${this.component.key} .swiper-pagination`,
                },
            });
        }
        // Allow basic component functionality to attach like field logic and tooltips.
        return super.attach(element);
    }
    updateValue(value, flags) {
        const changed = super.updateValue(value, flags);
        this.previousValue = this.dataValue;
        return changed;
    }
}
TextInfoComponent.editForm = TextInfo_form_1.default;
TextInfoComponent.builderInfo = {
    title: 'TextInfo',
    group: 'basic',
    icon: 'body-text',
    weight: 3,
    documentation: 'http://help.ari.form/userguide/',
    schema: TextInfoComponent.schema()
};
exports.default = TextInfoComponent;
